module.exports = __webpack_public_path__ + "static/media/to.0da693dc.svg";